import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full overflow-x-auto border border-[#d8d8e2] rounded-lg" }
const _hoisted_2 = { class: "w-full min-w-[900px] border-collapse" }
const _hoisted_3 = { class: "bg-[#f0f0f4]" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", { class: "px-4 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "shrink-0 w-10 h-10 rounded-full bg-slate-200" }),
    /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-1" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-28 bg-slate-200 rounded" }),
      /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-20 bg-slate-200 rounded" })
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "px-4 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col gap-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-24 bg-slate-200 rounded" }),
    /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-32 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", { class: "px-4 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center gap-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-3.5 w-20 bg-slate-200 rounded" }),
    /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-24 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "px-4 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-6 w-20 bg-slate-200 rounded-full" })
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { class: "px-4 py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "h-8 w-20 bg-slate-200 rounded" })
  ])
], -1)
const _hoisted_9 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]


export default /*#__PURE__*/_defineComponent({
  __name: 'FacialBiometryTableSkeleton',
  setup(__props) {

const columns = ['Médico', 'Escala', 'Data de envio', 'Status', 'Ações']

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (col) => {
            return _createElementVNode("th", {
              key: col,
              class: "px-4 py-2.5 text-sm font-bold text-[#272735] text-center"
            }, _toDisplayString(col), 1)
          }), 64))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
          return _createElementVNode("tr", {
            key: n,
            class: "border-t border-[#e8e8ed] bg-white animate-pulse"
          }, _hoisted_9)
        }), 64))
      ])
    ])
  ]))
}
}

})